import React, { useEffect, useState, useContext } from "react";
// import { Amplify } from "aws-amplify";
// import style from "./style.css";
// mui
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { appLogger, Http } from "../../utils";
// import { useSelector } from "react-redux";
import { UserContext } from "../../context/userContext";
import { UserLoginInfo } from "../../types/context";
import { useNavigate } from "react-router-dom";
import images from "../../global-styles/images";
import { withSnackbar } from "../../utils/common/SnackbarHoc";
import { AuthDetails, ROLE_USER_MANAGER, ROLE_USER_MEMBER, UserInfo, UserRoles } from "../../model";
import { useOktaAuth } from "@okta/okta-react";
import { Button } from "@mui/material";


declare global {
  interface Window {
    Cuvo: any;
  }
}

const HomeOkta = (props: any) => {
  const navigate = useNavigate();

  const [serverErrorShow, setServerErrorShow] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const { oktaAuth, authState } = useOktaAuth();

  const { userInfo, setUserInfo, setIsAuthenticated, orgId, loginInfo } = useContext(
    UserContext
  ) as UserLoginInfo;

  const loginOkta = async () => oktaAuth.signInWithRedirect();

  useEffect(() => {
    if (oktaAuth) {
      oktaAuth.isAuthenticated().then((res: any) => {
        if (res) {
          if (!(userInfo &&
            userInfo.isAuthenticated &&
            userInfo.accessToken && userInfo.idToken &&
            userInfo.userDetails)) {
            handleSuccessfulSignIn();
          }
        } else {
          const obj: AuthDetails = {
            isAuthenticated: false,
            idToken: "",
            accessToken: "",
            userDetails: {
              emailId: "",
              id: "",
              nameFirst: "",
              nameLast: "",
              active: false,
              createdBy: "",
              createdOn: 0,
              emailVerified: ""
            },
            isSsoUser: false
          };
          setUserInfo(obj);
        }
      });
    }
  }, []);

  useEffect(() => {
    Http.get({
      url: "/api/v2/organizations/0",
      customHeaders: { noauthvalidate: "true" },
    })
      .then((response: any) => {
        appLogger.info({ infoObj: { method: "useEffect", component: "homeOkta", fileName: "index.tsx", userInfo: response } });
      })
      .catch((error) => {
        appLogger.error({ errObj: { method: "useEffect", component: "homeOkta", fileName: "index.tsx", err: error } });
        setServerErrorShow(true);
      });
  }, []);

  const getUserInfo = async(token: string): Promise<any> => {
    const url = loginInfo.okta.issuer.endsWith('/') ? 
    loginInfo.okta.issuer.slice(0, -1) : loginInfo.okta.issuer;
    const resp = await fetch(`${url}/v1/userinfo`, {
      'method': 'GET',
      'headers': {
        'Authorization': `Bearer ${token}`,
      },
    });
    return resp.json();
  };

  const getUserRole = async(userId: string): Promise<UserRoles> => {
    const url = loginInfo.okta.apiUrl.endsWith('/') ? 
      loginInfo.okta.apiUrl.slice(0, -1) : loginInfo.okta.apiUrl;

    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", loginInfo.okta.apiKey);
    const resp = await fetch(`${url}/users/${userId}/groups`, {
      'method': 'GET',
      'headers': myHeaders,
      'redirect': 'follow'
    });
    const response = await resp.json();
    let role: UserRoles = ROLE_USER_MANAGER;
    if (response.length > 0) {
      const orgRoleMap: { [key: string]: UserRoles }  = loginInfo.okta ? loginInfo.okta.groupRoleMap : {};
      for (const group of response) {
        const groupName = group.profile.name;
        if (Object.keys(orgRoleMap).length && orgRoleMap[groupName]) {
          role = orgRoleMap[groupName];
        }
      }
      if (role) {
        return (role);
      }
    }
    return role;
  };

  const handleSuccessfulSignIn = async() => {
    const userName = authState ? authState.idToken ? authState.idToken.claims.name ? authState.idToken.claims.name : "" : "" : "";
    // The naming of id token and the access token is kept different for Okta
    // Because in okta the authentication is done using the access token
    // Whereas in cognito the authentication is done using the idToken
    // Because the code was written for cognito, id token is the main authentication token in the userInfo object
    // so assigning the okta access token to the idToken in the userInfo object
    const accessToken =  authState ? authState.idToken ? authState.idToken.idToken : "" : "";
    const idToken = authState ? authState.accessToken ? authState.accessToken.accessToken : "" : "";
    const emailId = authState ? authState.idToken ? authState.idToken.claims.email ? authState.idToken.claims.email : "" : "" : "";
    
    const userData: UserInfo = {
      emailId,
      id: '',
      nameFirst: '',
      nameLast: '',
      createdBy: '',
      createdOn: 0,
      active: true,
      emailVerified: "",
      userRole: ROLE_USER_MEMBER, // Write the ode to get the role. Right now we are hardcoding.
      orgId
    };

    const userInfoString = await getUserInfo(idToken);
    if (userInfoString) {
      const { sub, email, email_verified, given_name, family_name, updated_at } = userInfoString;
      userData.id = sub;
      userData.emailId = email;
      userData.active = email_verified;
      userData.nameFirst = given_name;
      userData.nameLast = family_name;
      userData.emailVerified = email_verified;
      userData.createdOn = updated_at;
      userData.createdBy = "";
      userData.orgId = orgId;
    }

    userData.userRole = await getUserRole(userData.id);

    if (accessToken && idToken && userName && emailId) {
      localStorage.setItem("authToken", accessToken);
      props.snackbarShowMessage("Login Successfully", "success");
      const obj: AuthDetails = {
        isAuthenticated: true,
        idToken,
        accessToken,
        userDetails: userData,
        isSsoUser: true
      };
      setUserInfo(obj);
      setIsAuthenticated(true);
      setIsloading(false);
      navigate("/dashboard");
    } else {
      setIsAuthenticated(false);
    }
  };

  return (
    <Box
      component="div"
      className={isLoading ? "loader auth-form" : "auth-form"}
    >
      <Container component="div" className="form-container">
        <Box className="logo-wrap">
          <img src={images.logoBlack} alt="Cuvo Logo" />
        </Box>

        {serverErrorShow ? (
          <Box sx={{ my: 5 }}>
            <Typography className="error-msg text-center">
              Internal server error
            </Typography>
          </Box>
        ) : (
          ""
        )}

        {
          oktaAuth ?
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{
              mt: "15px",
              mb: "15px",
              backgroundColor: (theme: any) => theme.palette.primary.main,
              textTransform: "uppercase",
            }}
            onClick={loginOkta}>SignIn Okta</Button> : <div></div>
        }

      </Container>
    </Box>
  );
};

export default withSnackbar(HomeOkta);
